import { render, staticRenderFns } from "./RefsDocument.vue?vue&type=template&id=31861e50"
import script from "./RefsDocument.vue?vue&type=script&lang=ts"
export * from "./RefsDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports